import Widget from "components/widget/Widget";
import { useLanguage } from "context/LanguageContext";
import { revenueKpiMock, formatVnd } from "../variables/revenueMock";
import { MdAttachMoney, MdPersonAdd, MdSchool, MdWarningAmber } from "react-icons/md";

const KpiGrid = () => {
  const { t } = useLanguage();
  const k = revenueKpiMock;
  const monthDiff = k.thisMonth - k.lastMonth;
  const sign = monthDiff >= 0 ? "+" : "-";
  const growthColor =
    monthDiff >= 0 ? "text-green-500" : "text-red-500";

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
      <div className="space-y-2">
        <Widget
          icon={<MdAttachMoney className="h-7 w-7" />}
          title={t("revenue.totalRevenue")}
          subtitle={formatVnd(k.totalRevenue)}
        />
        <p className={`text-xs font-semibold ${growthColor}`}>
          {sign}
          {t("revenue.thisMonth")}: {formatVnd(k.thisMonth)} (
          {k.growthPercent}%)
        </p>
      </div>

      <div className="space-y-2">
        <Widget
          icon={<MdSchool className="h-7 w-7" />}
          title={t("revenue.activeStudents")}
          subtitle={String(k.activeStudents)}
        />
        <p className="text-xs text-ink-muted">
          {t("revenue.avgPerStudent")}: {formatVnd(k.averagePerStudent)}
        </p>
      </div>

      <div className="space-y-2">
        <Widget
          icon={<MdPersonAdd className="h-7 w-7" />}
          title={t("revenue.newStudents")}
          subtitle={String(k.newStudents)}
        />
        <p className="text-xs text-ink-muted">
          {t("revenue.thisMonth")}
        </p>
      </div>

      <div className="space-y-2">
        <Widget
          icon={<MdWarningAmber className="h-7 w-7" />}
          title={t("revenue.outstanding")}
          subtitle={formatVnd(k.outstanding)}
        />
        <p className="text-xs text-ink-muted">
          {t("revenue.outstandingHint")}
        </p>
      </div>
    </div>
  );
};

export default KpiGrid;
